module.exports = __webpack_public_path__ + "img/resources-1920.b10f510e.jpg";